export default class PrintVehicle {
  constructor() {
    this.printBtn = document.getElementById('print-btn');
    if (this.printBtn) {
      this.init();
    }
  }

  init() {
    this.printBtn.addEventListener('click', this.handlePrint.bind(this));
  }

  handlePrint() {
    // Récupérer l'ID du véhicule
    const vehiculeId = document.querySelector('.single-vehicule').getAttribute('data-vehicle-id');

    if (vehiculeId) {
      // Créer un iframe caché pour l'impression
      const printFrame = document.createElement('iframe');
      printFrame.style.position = 'fixed';
      printFrame.style.right = '0';
      printFrame.style.bottom = '0';
      printFrame.style.width = '0';
      printFrame.style.height = '0';
      printFrame.style.border = '0';

      // URL de la page d'impression
      const printUrl = `/index.php/impression-de-vehicule/?id=${vehiculeId}&print=auto`;

      // Ajouter l'iframe au DOM
      document.body.appendChild(printFrame);

      // Attendre que l'iframe soit chargé pour lancer l'impression
      printFrame.onload = () => {
        try {
          // Attendre un peu que tout se charge correctement
          setTimeout(() => {
            printFrame.contentWindow.print();

            // Supprimer l'iframe après un délai (après l'impression)
            setTimeout(() => {
              document.body.removeChild(printFrame);
            }, 1000);
          }, 500);
        } catch (e) {
          console.error('Erreur lors de l\'impression:', e);
          // Fallback: ouvrir dans une nouvelle fenêtre
          window.open(printUrl, '_blank');
          document.body.removeChild(printFrame);
        }
      };

      // Définir la source de l'iframe
      printFrame.src = printUrl;
    } else {
      // Fallback si l'ID n'est pas disponible
      console.error("ID du véhicule non trouvé");
      window.print();
    }
  }
}
